<template>
  <div class="profile">
    <profile-header />
    <ul>
      <li v-for="link in links">
        <router-link :to="link.to">{{ link.title }}</router-link>
      </li>
      <li>
        <a
          :href="`${config.fileAbsUrl}/v1/document/get-user-manual`"
          target="_blank"
          download
          >Руководство</a
        >
      </li>
    </ul>
    <router-view></router-view>
  </div>
</template>
<style scoped>
ul {
  list-style-type: none;
  margin: 0;
  padding: 0 0 0 32px;

  overflow: hidden;
  background-color: #222d44;
}

li {
  float: left;
}

li a {
  display: block;
  color: white;
  text-align: center;
  padding: 16px;
  text-decoration: none;
  transition: 0.2s;
}
li a.router-link-exact-active {
  background-color: #1a75e9;
}

li a:hover {
  background-color: #192233;
}
</style>
<script>
import Header from "../components/profile/Header";
import config from "../config/index";
export default {
  data() {
    return {
      config: config,
      links: [
        {
          to: { name: "profile-docs" },
          title: "Документы"
        },
        {
          to: { name: "profile-settings-password" },
          title: "Смена пароля"
        }
      ]
    };
  },
  components: {
    "profile-header": Header
  }
};
</script>

<style scoped></style>
